<template>
    <div class="bottom_box">
        <img style="display: block;" src="../assets/imgs/dt_a.gif" height="197" width="1900" />
        <div class="homebottom">
          <table align="center" border="0" cellspacing="8" width="498">
            <tbody>
              <tr>
                <td colspan="3" align="center" height="60px">
                  <p>
                    <a href="http://www.drcnet.com.cn" target="_self">
                      <img src="http://images.drcnet-sod.com/images/common/drcnet_h.gif" hspace="4" />
                    </a>
                  </p>
                </td>
              </tr>
              <tr>
                <td align="center" height="50" width="68">&nbsp;</td>
                <td class="bottom" align="center" height="80" valign="bottom" width="410">
                  <div align="center" class="footer">
                    Copyright© 1998-{{new Date().getFullYear()}} DRCnet. All Rights Reserved
                    <br />版权所有 国研网
                    <br />
                    <a
                      href="https://beian.miit.gov.cn"
                      style="color:#000000"
                      target="_blank"
                    >京ICP证030059号</a>&nbsp;&nbsp;
                    <a
                      href="http://www.drcnet.com.cn/temp/20060413zheng/zhengshu.htm"
                      style="color:#000000"
                      target="_blank"
                    >中关村信用促进会会员证书</a>
                    <!-- 底部提示框 -->
                    <div class="advise">建议浏览器：ie9+、火狐、谷歌</div>
                  </div>
                </td>
                <td height="50" width="68">
                  <div align="center">
                    <a
                      href="http://www.hd315.gov.cn/beian/view.asp?bianhao=010202001050900196"
                      target="_blank"
                    >
                      <img
                        src="http://images.drcnet-sod.com/images/common/biaoshi.gif"
                        height="48"
                        border="0"
                        width="40"
                      />
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang='less' scoped>
.bottom_box{ position: relative;
   text-align: center;
   overflow: hidden;
	
}
.homebottom { margin: 30px 0; 
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 32%;
} 
.footer{
  font: 14px "宋体", "microsoft yahei", "Arial Narrow", HELVETICA;
  -webkit-text-size-adjust: 100%;
   color: #333; 
  line-height: 170%;
}
.advise{
  color: #333;
  font: 14px "宋体", "microsoft yahei", "Arial Narrow", HELVETICA;
  letter-spacing:2px;
}
</style>